import { createApp } from 'vue';
import PressContactCard from 'ewi-ui/components/2-molecules/PressContactCard';

const pressContactMountElement = document.getElementById('pressContactCard');

if (pressContactMountElement) {
  const dataset = pressContactMountElement.dataset;

  let contactDetails = [];
  try {
    if (dataset.contactdetails) {
      contactDetails = JSON.parse(dataset.contactdetails);
    }
  } catch (e) {
    console.error('Error parsing contact details:', e);
    console.error('Raw data:', dataset.contactdetails);
  }

  const app = createApp(PressContactCard, {
    headline: dataset.headline,
    text: dataset.text,
    customerServiceUrl: dataset.customerserviceurl,
    customerServiceButtonLabel: dataset.customerservicebuttonlabel,
    pressContactButtonLabel: dataset.presscontactbuttonlabel,
    theme: dataset.theme || 'light',
    contactHeadline: dataset.contactheadline,
    contactName: dataset.contactname,
    contactDetails: contactDetails,
    contactEmail: dataset.contactemail,
  });

  app.config.globalProperties.$window = window;

  app.mount(pressContactMountElement);
}
